import { render, staticRenderFns } from "./ResourceListFiltersChild.vue?vue&type=template&id=3dc1d848&scoped=true"
import script from "./ResourceListFiltersChild.vue?vue&type=script&lang=js"
export * from "./ResourceListFiltersChild.vue?vue&type=script&lang=js"
import style0 from "./ResourceListFiltersChild.vue?vue&type=style&index=0&id=3dc1d848&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc1d848",
  null
  
)

export default component.exports